module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("On arrival, he was condemned to incarceration in the vilest compound within the camp, the extra-secure section for "), _c('em', [_vm._v("Torsperre-")]), _vm._v("category prisoners, those who would not again pass through the prison gates. However, the Allied forces were advancing and as Hitler had ordered that no prisoners should fall in allied hands, the camp authorities vacated Neuengamme on 23 April. They took Eric to Lübeck, a port in the south-west corner of the Baltic Sea. This took days; part of the journey was on horrific death trains, the rest was on foot; he went through the hell of the death marches. After various ordeals, Eric ended up on the Cap Arcona, a previous line ship of the German merchant fleet, in which thousands of prisoners were packed like herrings in a vat.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("On 3 May 1945, whilst Germany’s capitulation was being arranged, the British Royal Air Force organised what would be their last major air raid. The Cap Arcona and another prisoner ship moored in the Bay of Lübeck were attacked. Within an hour from the start of the strike, more than seven thousand prisoners were dead. Nearly all were citizens of Holland, Belgium, France, Poland or other countries overrun by the Nazis. Today, a small monument on the coast near the border of Denmark bears witness to the carnage.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The bombardment was never explained: its purpose was obscured by the maximum level of secrecy being imposed on all relevant documents. These would be kept from scrutiny until 2045, a hundred years after the event. After the documents were made secret, there were few if any references to the attack left in WWII records. One of the few relevant papers known to exist is of a partly completed investigation by a British Major named Till. His task was to investigate war crimes but his superiors consistently hindered the comple- tion of his search for the cause of the fatal bombardment. Till recommended a formal investigation but it is not known if this took place. Even now, all infor- mation about the raid is kept under lock and key.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Of this, nothing was known in Groningen, where Kusha’s mother, Toni van der Laan, was also arrested. She was taken to Scholten House, opposite the City Hall. It was now the local headquarters of the German secret police. The van der Laan home was searched and everything was confiscated. Kusha and her brother where put on the street as bait – they were shadowed to see who would rescue them. They spent a few nights with frightened neighbours, and then the resistance movement managed to whisk them away. A brother of my uncle who had been taken to a concentration camp had to go under- ground, and he and his wife found refuge in our summer cottage. Kusha and her brother were taken there, and the childless couple looked after them as if they were their children.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("When Toni van der Laan was released, probably also to lure others involved in the resistance, she too was secretly relocated by the resistance movement and allocated a hideout in a forest not far from our summer cottage. There, she was reunited with her children, all were given new identities. Their lives")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3147290","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0036.vue
// module id = 168
// module chunks = 0